/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.15.8
 * source: src/proto/HgProto.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "@thegraid/wspbclient";
import * as pb_1 from "google-protobuf";
export enum HgType {
    hg_none = 0,
    hg_makeMove = 1,
    hg_sendMove = 2,
    hg_progress = 3,
    hg_setParam = 4,
    hg_next = 6,
    hg_undo = 7,
    hg_join = 8,
    hg_chat = 9
}
export enum hgField {
    hgField_0 = 0,
    hgField_type = 1,
    hgField_client = 2,
    hgField_player = 3,
    hgField_name = 4,
    hgField_json = 5,
    hgField_inform = 7,
    hgField_roster = 10,
    hgField_client_to = 11
}
export class HgMsgBase extends pb_1.Message {
    #one_of_decls: number[][] = [];
    get has_type() { return pb_1.Message.getField(this, hgField.hgField_type) }
    get has_client() { return pb_1.Message.getField(this, hgField.hgField_client) }
    get has_player() { return pb_1.Message.getField(this, hgField.hgField_player) }
    get has_name() { return pb_1.Message.getField(this, hgField.hgField_name) }
    get has_json() { return pb_1.Message.getField(this, hgField.hgField_json) }
    get has_inform() { return pb_1.Message.getField(this, hgField.hgField_inform) }
    get has_roster() { return this.roster?.length > 0 }
    get has_client_to() { return pb_1.Message.getField(this, hgField.hgField_client_to) }

    constructor(data?: any[] | {
        type?: HgType;
        client?: number;
        player?: number;
        name?: string;
        json?: string;
        inform?: string;
        roster?: dependency_1.Rost[];
        client_to?: number;
    }) {
        super();
        pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [10], this.#one_of_decls);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("type" in data && data.type != undefined) {
                this.type = data.type;
            }
            if ("client" in data && data.client != undefined) {
                this.client = data.client;
            }
            if ("player" in data && data.player != undefined) {
                this.player = data.player;
            }
            if ("name" in data && data.name != undefined) {
                this.name = data.name;
            }
            if ("json" in data && data.json != undefined) {
                this.json = data.json;
            }
            if ("inform" in data && data.inform != undefined) {
                this.inform = data.inform;
            }
            if ("roster" in data && data.roster != undefined) {
                this.roster = data.roster;
            }
            if ("client_to" in data && data.client_to != undefined) {
                this.client_to = data.client_to;
            }
        }
    }
    get type() {
        return pb_1.Message.getFieldWithDefault(this, 1, HgType.hg_none) as HgType;
    }
    set type(value: HgType) {
        pb_1.Message.setField(this, 1, value);
    }
    get client() {
        return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
    }
    set client(value: number) {
        pb_1.Message.setField(this, 2, value);
    }
    get player() {
        return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
    }
    set player(value: number) {
        pb_1.Message.setField(this, 3, value);
    }
    get name() {
        return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
    }
    set name(value: string) {
        pb_1.Message.setField(this, 4, value);
    }
    get json() {
        return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
    }
    set json(value: string) {
        pb_1.Message.setField(this, 5, value);
    }
    get inform() {
        return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
    }
    set inform(value: string) {
        pb_1.Message.setField(this, 7, value);
    }
    get roster() {
        return pb_1.Message.getRepeatedWrapperField(this, dependency_1.Rost, 10) as dependency_1.Rost[];
    }
    set roster(value: dependency_1.Rost[]) {
        pb_1.Message.setRepeatedWrapperField(this, 10, value);
    }
    get client_to() {
        return pb_1.Message.getFieldWithDefault(this, 11, 0) as number;
    }
    set client_to(value: number) {
        pb_1.Message.setField(this, 11, value);
    }
    static fromObject(data: {
        type?: HgType;
        client?: number;
        player?: number;
        name?: string;
        json?: string;
        inform?: string;
        roster?: ReturnType<typeof dependency_1.Rost.prototype.toObject>[];
        client_to?: number;
    }): HgMsgBase {
        const message = new HgMsgBase({});
        if (data.type != null) {
            message.type = data.type;
        }
        if (data.client != null) {
            message.client = data.client;
        }
        if (data.player != null) {
            message.player = data.player;
        }
        if (data.name != null) {
            message.name = data.name;
        }
        if (data.json != null) {
            message.json = data.json;
        }
        if (data.inform != null) {
            message.inform = data.inform;
        }
        if (data.roster != null) {
            message.roster = data.roster.map(item => dependency_1.Rost.fromObject(item));
        }
        if (data.client_to != null) {
            message.client_to = data.client_to;
        }
        return message;
    }
    toObject() {
        const data: {
            type?: HgType;
            client?: number;
            player?: number;
            name?: string;
            json?: string;
            inform?: string;
            roster?: ReturnType<typeof dependency_1.Rost.prototype.toObject>[];
            client_to?: number;
        } = {};
        if (this.type != null) {
            data.type = this.type;
        }
        if (this.client != null) {
            data.client = this.client;
        }
        if (this.player != null) {
            data.player = this.player;
        }
        if (this.name != null) {
            data.name = this.name;
        }
        if (this.json != null) {
            data.json = this.json;
        }
        if (this.inform != null) {
            data.inform = this.inform;
        }
        if (this.roster != null) {
            data.roster = this.roster.map((item: dependency_1.Rost) => item.toObject());
        }
        if (this.client_to != null) {
            data.client_to = this.client_to;
        }
        return data;
    }
    serialize(): Uint8Array;
    serialize(w: pb_1.BinaryWriter): void;
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
        const writer = w || new pb_1.BinaryWriter();
        if (this.type != HgType.hg_none)
            writer.writeEnum(1, this.type);
        if (this.client != 0)
            writer.writeInt32(2, this.client);
        if (this.player != 0)
            writer.writeInt32(3, this.player);
        if (this.name.length)
            writer.writeString(4, this.name);
        if (this.json.length)
            writer.writeString(5, this.json);
        if (this.inform.length)
            writer.writeString(7, this.inform);
        if (this.roster.length)
            writer.writeRepeatedMessage(10, this.roster, (item: dependency_1.Rost) => item.serialize(writer));
        if (this.client_to != 0)
            writer.writeInt32(11, this.client_to);
        if (!w)
            return writer.getResultBuffer();
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): HgMsgBase {
        const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new HgMsgBase();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
                case 1:
                    message.type = reader.readEnum();
                    break;
                case 2:
                    message.client = reader.readInt32();
                    break;
                case 3:
                    message.player = reader.readInt32();
                    break;
                case 4:
                    message.name = reader.readString();
                    break;
                case 5:
                    message.json = reader.readString();
                    break;
                case 7:
                    message.inform = reader.readString();
                    break;
                case 10:
                    reader.readMessage(message.roster, () => pb_1.Message.addToRepeatedWrapperField(message, 10, dependency_1.Rost.deserialize(reader), dependency_1.Rost));
                    break;
                case 11:
                    message.client_to = reader.readInt32();
                    break;
                default: reader.skipField();
            }
        }
        return message;
    }
    serializeBinary(): Uint8Array {
        return this.serialize();
    }
    static override deserializeBinary(bytes: Uint8Array): HgMsgBase {
        return HgMsgBase.deserialize(bytes);
    }
}
